import { useCallback, useMemo } from "react";

import { leftToRightMark, rightToLeftMark, useDirection } from "@jti/fe-common";

export const useTextSeparatorWithDirectionalMark = () => {
  const direction = useDirection();

  const [ltrSeparator, rtlSeparator] = [", ", "، "];

  const separator = direction === "rtl" ? `${rightToLeftMark}${rtlSeparator}` : `${leftToRightMark}${ltrSeparator}`;

  const joinWithSeparator = useCallback(
    (...parts: Array<string | null | undefined>): string => {
      return parts.filter(Boolean).join(separator);
    },
    [separator]
  );

  return useMemo(() => {
    return {
      joinWithSeparator,
      separator,
    };
  }, [joinWithSeparator, separator]);
};
